import {defaultUser} from '../constants/AppConst';

export const useAuthUser = () => {
  return {
    isLoading: false,
    isAuthenticated: true,
    user: defaultUser,
  };
};
